module.exports = __webpack_public_path__ + "static/media/status-badge-persona.5457a268.svg";